import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "../../SellingPricesList.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditSellingPrice from "../../../AddEditSellingPrice";
import { ActionDiv } from "../EnquirySellingPrice/EnquirySellingPrice.styled";
import "../../SellingPricesList.scss";

const SellingPriceAction = (props) => {
  const {
    t,
    id,
    isActive,
    onRefreshData,
    updateRefeshStatus,
    currentSellingPrice,
    enquiryData,
    selectedSolutionsIds,
  } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isEditSellingPricePopupVisible, setIsEditSellingPricePopupVisible] =
    useState(false);
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "SELLING_PRICE_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "SELLING_PRICE_CONFIRMATION_BOX_DELETE_CONTENT"
  );
  const handleSellingPricelDisable = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("SELLING_PRICE_ACTION_TOOLTIP_ACTIVATE");
      setConfirmationBoxContent(
        "SELLING_PRICE_ACTION_TOOLTIP_ACTIVATE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("SELLING_PRICE_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "SELLING_PRICE_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      const formStatus = isActive === 1 ? "0" : 1;
      axios
        .put(`/sellingPrices/${id}/updateStatus/${formStatus}`)
        .then(() => {
          onRefreshData(true);
          setActionConfirmStatus(false);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editSellingPrice = (action) => {
    setIsEditSellingPricePopupVisible(true);
  };

  const closeSellingPriceEditPopup = () => {
    setIsEditSellingPricePopupVisible(false);
  };

  return (
    <ActionDiv>
      <ButtonContainer>
        <div>
          <Image
            src={editIcon}
            className="selling-price-list__image-price-action-icon"
            title={t("SELLING_PRICE_ACTION_TOOLTIP_EDIT")}
            onClick={editSellingPrice}
            alt={t("SELLING_PRICE_ACTION_TOOLTIP_EDIT")}
          />
          {isActive === 1 && !isConfirm && (
            <Image
              src={deleteIcon}
              className="selling-price-list__image-price-action-icon"
              onClick={() => handleSellingPricelDisable(2)}
              alt={t("SELLING_PRICE_ACTION_TOOLTIP_DELTE")}
              title={t("SELLING_PRICE_ACTION_TOOLTIP_DELTE")}
            />
          )}
          {isActive !== 1 && !isConfirm && (
            <Image
              src={activateIcon}
              className="selling-price-list__image-price-action-icon"
              onClick={() => handleSellingPricelDisable(1)}
              alt={t("SELLING_PRICE_ACTION_TOOLTIP_ACTIVATE")}
              title={t("SELLING_PRICE_ACTION_TOOLTIP_ACTIVATE")}
            />
          )}
        </div>
      </ButtonContainer>

      {isConfirm && <ClipLoader size={15} color="#cccccc" />}
      {isEditSellingPricePopupVisible && (
        <AddEditSellingPrice
          onClose={closeSellingPriceEditPopup}
          id={id}
          sellingPriceData={currentSellingPrice}
          enquiryId={currentSellingPrice?.requestId}
          enquiryData={enquiryData}
          onRefreshData={onRefreshData}
          countryId={parseInt(enquiryData?.site?.platformCountry.id, 10)}
          isEditMode
          selectedSolutionsIds={selectedSolutionsIds}
        />
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ActionDiv>
  );
};

SellingPriceAction.propTypes = {
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(SellingPriceAction);
